import { darkColors } from '../../theme/colors'
import { ButtonTheme, variants } from './types'

const { PRIMARY, SECONDARY, OUTLINED, TEXT } = variants

export const dark: ButtonTheme = {
  [PRIMARY]: {
    background: darkColors.purple,
    backgroundHover: darkColors.purpleHover,
    backgroundDisabled: darkColors.gray8,
    color: darkColors.white,
    colorDisabled: darkColors.white4
  },
  [SECONDARY]: {
    background: darkColors.gray10,
    backgroundHover: darkColors.gray9,
    backgroundDisabled: darkColors.gray8,
    color: darkColors.white,
    colorDisabled: darkColors.white3
  },
  [OUTLINED]: {
    background: 'transparent',
    backgroundHover: darkColors.white,
    backgroundDisabled: 'transparent',
    color: darkColors.text,
    colorDisabled: darkColors.white3,
    border: `1px solid ${darkColors.white}`,
    borderHover: `1px solid ${darkColors.white}`,
    borderDisabled: `1px solid ${darkColors.white3}`,
    colorHover: darkColors.background
  },
  [TEXT]: {
    background: 'transparent',
    backgroundHover: 'transparent',
    backgroundDisabled: 'transparent',
    color: darkColors.text,
    colorDisabled: darkColors.white3,
    colorHover: darkColors.purple
  }
}

export const light: ButtonTheme = {
  [PRIMARY]: {
    ...dark.primary
  },
  [SECONDARY]: {
    ...dark.secondary
  },
  [OUTLINED]: {
    ...dark.outlined
  },
  [TEXT]: {
    ...dark.text
  }
}
